// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"8980274a","136":"f7843d86","153":"cb5eff94","237":"3d8463cd","390":"59f9a0a7","433":"f062fe62","453":"ba36cf83","457":"dd8204fa"}[chunkId] + ".chunk.js";
};